var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.noData || _vm.loading
    ? _c(
        "div",
        _vm._b({}, "div", _vm.feedbackStyles, false),
        [
          _vm.title
            ? _c("div", { class: ["feedback-title", _vm.titleClass] }, [
                _vm._v(" " + _vm._s(_vm.title) + " ")
              ])
            : _vm._e(),
          _vm.loading
            ? _c(
                "BaseLoadingSkeleton",
                _vm._b(
                  { attrs: { width: "100%" } },
                  "BaseLoadingSkeleton",
                  _vm.feedbackSkeleton,
                  false
                )
              )
            : _vm.noData && !_vm.loading
            ? _c(
                "div",
                { staticClass: "feedback-content pa-4 d-flex flex-column" },
                [
                  _c("icon-svg", {
                    staticClass: "mb-4",
                    attrs: {
                      size: "40",
                      name: _vm.iconName,
                      color: _vm.iconColor
                    }
                  }),
                  _vm.hasContentSlot
                    ? [_vm._t("content")]
                    : [
                        _vm.message
                          ? _c("p", { staticClass: "ma-0 feedback-message" }, [
                              _vm._v(" " + _vm._s(_vm.message) + " ")
                            ])
                          : _vm._e(),
                        _c(
                          "div",
                          { class: _vm.buttonWrapperClasses },
                          [_vm._t("button")],
                          2
                        )
                      ]
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    : _c("div", { staticClass: "slot-wrapper" }, [_vm._t("default")], 2)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }